var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-card",
        [
          _c("w-card-title", [_vm._v("Ticket overzicht")]),
          _c(
            "w-card-content",
            { style: { padding: "15px 15px" } },
            [
              _c(
                "div",
                { style: { display: "flex", marginBottom: "5px" } },
                [
                  _c("w-date-picker", {
                    style: { flexGrow: 0 },
                    attrs: { fancy: "", label: "Datum" },
                    model: {
                      value: _vm.date,
                      callback: function ($$v) {
                        _vm.date = $$v
                      },
                      expression: "date",
                    },
                  }),
                  _c("w-spacer"),
                ],
                1
              ),
              _c(
                "w-scroll-view",
                {
                  style: {
                    height: "calc(100vh - 200px)",
                    padding: "0 0 100px 0",
                  },
                  attrs: { tag: "w-container" },
                },
                [
                  _vm.tickets.length == 0
                    ? _c("div", { staticClass: "mt" }, [
                        _c("b", [_vm._v("Geen gegevens gevonden")]),
                      ])
                    : _vm._l(_vm.list, function (t, index) {
                        return _c(
                          "div",
                          { key: index },
                          [
                            _c("div", { staticClass: "username" }, [
                              _vm._v(
                                " " + _vm._s(_vm.getAdminName(index)) + " "
                              ),
                            ]),
                            _c(
                              "w-row",
                              [
                                _c(
                                  "w-col",
                                  {
                                    style: { maxWidth: "100px" },
                                    attrs: { md: "2" },
                                  },
                                  [_c("b", [_vm._v("Ticket ID")])]
                                ),
                                _c(
                                  "w-col",
                                  {
                                    style: { maxWidth: "150px" },
                                    attrs: { md: "2" },
                                  },
                                  [_c("b", [_vm._v("Klant")])]
                                ),
                                _c(
                                  "w-col",
                                  {
                                    style: { maxWidth: "100px" },
                                    attrs: { md: "2" },
                                  },
                                  [_c("b", [_vm._v("Tijdstip")])]
                                ),
                                _c("w-col", { attrs: { md: "8" } }, [
                                  _c("b", [_vm._v("Onderwerp")]),
                                ]),
                              ],
                              1
                            ),
                            _vm._l(t.tickets, function (row, i) {
                              return _c(
                                "w-row",
                                { key: "list" + i },
                                [
                                  _c(
                                    "w-col",
                                    {
                                      style: { maxWidth: "100px" },
                                      attrs: { md: "2" },
                                    },
                                    [
                                      _c(
                                        "w-link",
                                        {
                                          attrs: {
                                            to: "/ticket/" + row.ticket.id,
                                            target: "_blank",
                                          },
                                        },
                                        [_vm._v(_vm._s(row.ticket.id))]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    {
                                      style: { maxWidth: "150px" },
                                      attrs: { md: "2" },
                                    },
                                    [_vm._v(_vm._s(row.ticket.company.name))]
                                  ),
                                  _c(
                                    "w-col",
                                    {
                                      style: { maxWidth: "100px" },
                                      attrs: { md: "2" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatTime(row.timeFirstRead)
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("w-col", { attrs: { md: "8" } }, [
                                    _vm._v(_vm._s(row.ticket.subject)),
                                  ]),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        )
                      }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }